import { Component } from '@angular/core';

@Component({
  selector: 'app-cadastrar-profissionais',
  imports: [],
  templateUrl: './cadastrar-profissionais.component.html',
  styleUrl: './cadastrar-profissionais.component.scss'
})
export class CadastrarProfissionaisComponent {

}
